import { Component, Input } from "@angular/core";
import { Subscription, timer } from "rxjs";
import { trigger, transition, style, animate } from "@angular/animations";

@Component({
  selector: "ds-splash-screen",
  templateUrl: "./ds-splash-screen.component.html",
  styleUrls: ["./ds-splash-screen.component.scss"],
  animations: [
    trigger("fadeInScale", [
      transition(":enter", [
        style({
          opacity: 0,
        }),
        animate(
          "100ms ease-out",
          style({
            opacity: 1,
          })
        ),
      ]),
      transition(":leave", [
        animate(
          "100ms ease-in",
          style({
            opacity: 0,
          })
        ),
      ]),
    ]),
  ],
})
export class DsSplashScreenComponent {
  @Input() initial_message: string = "";
  @Input() progress_message: string = "Espera un momento...";
  @Input() fallback_message: string = "Esto puede tardar un poco más, seguimos trabajando…";
  @Input() description: string = "";

  message: string = "";
  timerSubscription!: Subscription;

  constructor() {}

  ngOnInit() {
    this.message = this.initial_message;
    this.timerSubscription = timer(5000).subscribe(() => {
      this.message = this.progress_message;

      timer(5000).subscribe(() => {
        this.message = this.fallback_message;
      });
    });
  }

  ngOnDestroy() {
    this.timerSubscription?.unsubscribe();
  }
}
